<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>品牌管理
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">数据列表</div>
        <div class="create">
          <button @click="create()" class="btn1">添加品牌</button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="brand"
          ref="multipleTable"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label width="40" type="selection"></el-table-column>
          <el-table-column label="品牌名称" prop="name" width="100" style="text-align:center"></el-table-column>
          <el-table-column prop="main_products" label="主要产品" width="150"></el-table-column>
          <el-table-column prop="logo" label="品牌logo">
            <template slot-scope="scope">
              <img class="cover" v-bind:src="serve+'/'+scope.row.logo" />
            </template>
          </el-table-column>
          <el-table-column prop="order_by" label="排序"></el-table-column>
          <el-table-column prop="show" label="是否显示">
            <template slot-scope="scope">
              <el-switch
                @change="up_down(scope.row.id)"
                v-model="scope.row.show"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <button @click="edit(scope.row.id)" class="button1">编辑</button>
              <button @click="del_brand(scope.row.id)" class="button1">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pager">
        <el-row>
          <el-col :span="2" style="padding-left:10px;">
            <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox>
          </el-col>
          <el-col :span="8">
            <button @click="del()" class="btn1">批量删除</button>
          </el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pages*10"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "gallery",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      selectAll: false,
      idString: "",
      brand: [],
      page: null,
      total: null,
      pages: null,
      values: [],
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token")
    };
  },
  watch: {
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.selectAll();
      }
    }
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "品牌管理";
  },
  methods: {
    up_down(id) {
      this.axios.get(this.serve + "/admin/show_brand", {
        params: {
          id: id,
          token: this.token,
          username: this.username
        }
      });
    },
    edit(id) {
      this.$router.push({
        path: "/admin/edit_brand/" + id
      });
    },
    toggleSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    setPage(v) {
      this.page = v;
      this.getData(v);
      this.selectAll = false;
    },
    getData(page) {
      var that = this;
      this.axios
        .get(this.serve + "/admin/get_brand", {
          params: { page: page, token: this.token, username: this.username }
        })
        .then(res => {
        
          if (res.status == "200" && res.data.code != "403") { 
            var json = res.data;
            that.page = json.now_page;
            that.pages = json.page_num;
            var newBrand = [];
            for (var key in json) {
              if (json[key].name) {
                newBrand.push(json[key]);
              }
            }
            that.brand = [];
            that.brand = newBrand;
          } else if (res.data.status == "error" || res.data.code == "403") {
            this.role = false;
          }
          /*if (res.data.status == "success") {
            var json = res.data;
            that.page = json.now_page;
            that.pages = json.page_num;
            var newBrand = [];
            for (var key in json) {
              if (json[key].name) {
                newBrand.push(json[key]);
              }
            }
            that.brand = [];
            that.brand = newBrand;
          } else if (res.data.status == "error" && res.data.code == "403") {
            this.role = false;
          }*/
        });
    },
    del() {
      var that = this;
      this.$confirm("删除后不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/del_brand", {
              params: {
                id: this.idString,
                token: this.token,
                username: this.username
              }
            })
            .then(function(res) {
              if (res.data.status == "success") {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.getData(that.page);
              } else {
                that.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    create() {
      this.$router.push({
        path: "/admin/add_brand"
      });
    },
    handleSelectionChange(val) {
      this.idString = "";
      var tmpString = "";
      for (var item of val) {
        if (tmpString == "") {
          tmpString = item.id;
        } else {
          tmpString = tmpString + "," + item.id;
        }
      }
      this.idString = tmpString;
    },

    del_brand(id) {
      var that = this;
      this.$confirm("删除后不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/del_brand", {
              params: {
                token: this.token,
                username: this.username,
                id: id
              }
            })
            .then(function(res) {
              if (res.data.status == "success") {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.getData(that.page);
              }else if(res.data.code == '403'){
                  that.$message.error(res.data.msg);
              } else {
                that.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.brand-page {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }
  .create {
    float: right;
    margin-right: 20px;
    padding-top: 7px;
  }
  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .el-table th > .cell {
    text-align: center;
  }
  .cell {
    text-align: center;
  }
  .btn2 {
    margin-right: -74px;
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
}
</style>

